<template>
  <section>
    <md-field>
      <label>Your name</label>
      <md-input v-model="clientName" ref="clientNameInput"></md-input>
    </md-field>
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <md-field>
          <label>Your email address</label>
          <md-input
            v-model="yourEmail"
            placeholder="email@email.com"
          ></md-input>
          <md-tooltip md-direction="bottom" v-if="hasContactDetail"
            >Please click "Book Now" button to complete your booking
            request.</md-tooltip
          >
        </md-field>
      </div>
      <div class="md-layout-item">
        <md-field>
          <label>Your phone number</label>
          <md-input
            type="tel"
            v-model="yourTel"
            placeholder="0777666555"
          ></md-input>
        </md-field>
      </div>
    </div>

    <md-list class="md-double-line">
      <md-subheader>Book treatment</md-subheader>

      <md-list-item @click="treatment = true">
        <div class="md-list-item-text">
          <span>{{ selectedTreatment ? selectedTreatment.name : null }}</span>
          <span>{{ selectedTreatment ? selectedTreatment.price : null }}</span>
        </div>
      </md-list-item>
      <md-list-item @click="dateTime = true">
        <div class="md-list-item-text">
          <span>{{ selectedAppointmentDateString }}</span>
          <span>At {{ selectedTime }}</span>
        </div>
      </md-list-item>
    </md-list>
  </section>
</template>

<script>
import { eventBus } from "../eventbus";
//import firebase from "../../../firebaseConfig";

//const db = firebase.firestore();

export default {
  name: "FillInContactDetails",
  data: function () {
    return {
      yourEmail: null,
      yourTel: null,
      clientName: null,
      hasBooked: false,
      showContactForm: true,
      showBookNowButton: true,
      isBookNowFirstLoadPage: false,
      creationStartedAt: new Date()
    };
  },
  computed: {
    hasContactDetail() {
      var isTel = this.yourTel?.length > 2 && this.strHasNumbers(this.yourTel);
      var isEmail = this.yourEmail?.indexOf("@") > -1;
      var isInputValid = isTel || isEmail;

      var clientDetails = {
        clientName: this.clientName,
        clientTel: this.yourTel,
        clientEmail: this.yourEmail,
        creationStartedAt: this.creationStartedAt
      };

      if (isInputValid) {
        eventBus.contactDetailsValid(clientDetails);
      } else {
        eventBus.contactDetailsInvalid(clientDetails);
      }

      return isInputValid;
    },

    showBookNowPage() {
      var isVisible = this.timeReserved && this.showContactForm;

      return isVisible;
    },
    selectedAppointmentDateString() {
      
      if (this.selectedDate == null) return;
      var day = getDayName(this.selectedDate);

      return "On " + day + " " + this.selectedDate.toLocaleDateString();

      function getDayName(dateStr, locale) {
        var date = new Date(dateStr);
        return date.toLocaleDateString(locale, { weekday: "long" });
      }
    },
    selectedDate(){
      return this.$store.state.user.selectedDate;
    },
    selectedTreatment() {
      return this.$store.state.user.selectedTreatment;
    },
    selectedTime() {
      return this.$store.state.user.selectedTime;
    },
  },
  methods: {
    strHasNumbers: function (s) {
      var matches = s.match(/\d+/g);
      if (matches != null) {
        return true;
      }
      return false;
    },
  },
  created: function () {},
  updated: function () {
    if (this.showBookNowPage && !this.isBookNowFirstLoadPage) {
      this.isBookNowFirstLoadPage = true;
      this.$refs.clientNameInput.$el.focus();
      eventBus.updateDialogTitle("Contact info");
    }
  },
};
</script>

<style>
</style>